<div class="modal fade" id="errorModalDialog{{modalId}}" tabindex="-1" role="dialog" aria-labelledby="errorModalDialog"
	aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-lg" role="document" [ngClass]="dialogClass">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img src="/assets/images/icons/close_b.svg" />
                    CLOSE WINDOW
				</button>
			</div>
			<div class="modal-body">
				<h5 class="modal-title w-100 font-mont-bold" id="exampleModalLongTitle">{{title}}</h5>

                <div [ngClass]="messageAClass">{{messageA}}</div>
                <div [ngClass]="messageBClass">{{messageB}}</div>
				<div [ngClass]="messageCClass">{{messageC}}</div>
				
				<div class="text-center row">
					<div class="col-12">
						<button type="button" class="btn btn-primary close-button" data-dismiss="modal" (click)="onCloseModal();">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>